// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sJR9_","colMin":"styles_colMin__1IXBj"};